import { Badge } from "components/ui/badge";
import React from "react";
import { useFeature } from "store/selectors/hooks";
import { ClientTransferRequestSummary, ClientTransferSubject } from "./transfer-types";

const subjectKindLabels: Record<ClientTransferSubject["kind"], string> = {
    placement: "Placement",
    homeCareLead: "Home Care",
};

interface TransferSubjectHeadingProps {
    clientTransferRequest: ClientTransferRequestSummary;
}

export const TransferSubjectHeading: React.FC<TransferSubjectHeadingProps> = props => {
    const { clientTransferRequest } = props;
    const placementEnabled = useFeature("placement");
    const homeCareEnabled = useFeature("homeCarePrototype");
    const hasBothNames =
        clientTransferRequest.subjectBestContactName && clientTransferRequest.subjectName;

    return (
        <div className="flex items-start space-x-2">
            <div className="flex-1">
                {hasBothNames ? (
                    <div>
                        {clientTransferRequest.subjectBestContactName}
                        <br />
                        {clientTransferRequest.subjectName}
                    </div>
                ) : (
                    clientTransferRequest.subjectName ||
                    clientTransferRequest.subjectBestContactName ||
                    "(no name)"
                )}
            </div>
            {placementEnabled && homeCareEnabled ? (
                <Badge
                    type="info"
                    value={subjectKindLabels[clientTransferRequest.subject.kind]}
                />
            ) : null}
        </div>
    );
};
